import { ComposantGroupeSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const ComposantGroupeModel: SelectorModel = {
  name: 'composantGroupes',
  getSelector: ComposantGroupeSelectors.selectAllComposantGroupesDictionary,
  isReady: ComposantGroupeSelectors.selectIsReadyComposantGroupe
};
